<template>
  <v-app>
    <header>
      <canvas class="header_canvas" data-js-controller="Gradient" data-js-darken-top="" data-transition-in=""
        width="1335" height="600"></canvas>
    </header>
    <v-container class="main_wrap">
      <v-main>
        <front-page-toolbar />
        <v-row class="pt-10 pb-10">
          <v-col class="d-flex justify-center" v-if="!signUpLoading">
            <v-card width="38vw" min-width="400px" class="gradient-info">
              <v-card-text>
                <h3>{{ $t('you-will-get') }}</h3>
                <v-divider/>
                <div>
                  {{ $t('full-control-over-equipment-and-orders') }}
                </div>
                <div>
                  {{ $t('efficient-handling-of-service-requests') }}
                </div>
                <div>
                  {{ $t('easy-digital-management') }}
                </div>
                <div>
                  {{ $t('much-more') }} <a href="https://www.qwips.no/#qwips-content" target="_blank">({{ $t('read') }})</a>
                </div>
              </v-card-text>
              </v-card>
          </v-col>
          <v-col class="d-flex justify-center">
            <v-card width="38vw" min-width="400px" :elevation="20" class="pt-5" style="z-index: 22"
              v-if="!signUpLoading">
              <v-card-title class="pb-2 pl-8">
                {{ $t("signup-title") }}
              </v-card-title>
              <v-card-text class="ml-5">
                <strong>
                  {{ $t('no-comittment') }} – {{ $t('test-without-any-obligation') }}
                </strong>
                <ul class="ml-5">
                  <li>{{ $t('get-started-in-minutes') }}</li>
                  <li>{{ $t('full-access-to-all-features-during-the-trial-period') }}</li>
                  <li>{{ $t('what-happens-after-30-days') }}
                    <ul class="pl-2">
                      <li>{{ $t('the-site-will-be-in-read-only-mode') }}</li>
                      <li>{{ $t('pay-with-card-continue-using-after-payment-has-been-completed') }}</li>
                      <li>{{ $t('pay-invoice-contact-us-for-a-custom-payment') }}</li>
                    </ul>
                  </li>
                </ul>
                <a href="#" @click.stop="">{{ $t('more-questions') }} (FAQ)</a>
              </v-card-text>
              <v-divider/>
              <v-form v-model="valid" @submit="signup">
                <v-card-text class="pt-10 pb-0">
                  <v-text-field label="Company Name" variant="outlined" dense color="primary" autofocus
                    :rules="companyRules" v-model="dto.companyName"></v-text-field>
                  <div class="pb-5" v-if="validCompany">
                    <div d-flex>
                      <small>
                        <v-tooltip :text="$t('configure-domain-tooltip')">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props">mdi-information-outline</v-icon>
                          </template>
                        </v-tooltip>
                        Domain: {{ prefix }}.qwips.net
                      </small>
                      <small>
                        <a href="#" @click="enterCustomCompanyPrefix = true">
                          (change)
                        </a>
                      </small>
                      <v-icon color="success" v-if="companyPrefixIsValid">mdi-check</v-icon>
                      <v-tooltip :text="$t('invalid-domain-name-this-domain-name-is-reserved')">
                        <template v-slot:activator="{ props }">
                          <v-icon v-bind="props" color="error"
                            v-if="companyPrefixIsValid == false">mdi-alert-outline</v-icon>
                        </template>
                      </v-tooltip>
                      <v-progress-circular indeterminate v-if="companyPrefixValidation" size="16"></v-progress-circular>
                    </div>
                    <div class="d-flex" v-if="enterCustomCompanyPrefix">
                      <v-text-field density="compact" v-model="companyPrefix" variant="outlined" hide-details
                        @keypress="setCompanyPrefix($event)"></v-text-field>
                      <v-btn class="my-auto mx-2"
                        @click="enterCustomCompanyPrefix = false; customCompanyPrefix = true; dto.companyUrlPrefix = companyPrefix"
                        color="primary">Save</v-btn>
                    </div>
                  </div>

                  <v-text-field :rules="nameRules" v-model="dto.name" label="Name" variant="outlined" dense
                    color="primary"></v-text-field>
                  <v-text-field :rules="emailRules" v-model="dto.email" label="Email" variant="outlined" dense
                    color="primary"></v-text-field>
                  <v-checkbox :rules="[(val) => val === true || $t('you-must-accept-the-license-agreement')]"
                    v-model="terms"><template
                      v-slot:label>I agree to the terms and conditions. <a href="#"
                        @click.prevent="termsOfService"
                        style="text-decoration: underline;">(open)</a></template></v-checkbox>
                </v-card-text>
                <v-card-text class="pl-10">
                  <VueRecaptcha v-if="recaptcha" :loadRecaptchaScript="true" @verify="validate" :sitekey="recaptcha">
                  </VueRecaptcha>
                </v-card-text>
                <v-card-actions class="pb-6 mx-10">
                  <v-spacer />
                  <v-btn color="primary" size="large" block tonal
                    :disabled="!canSignUp || !valid || !recaptchaValid || !companyPrefixIsValid" type="submit">
                    Sign up</v-btn>
                  <v-spacer />
                </v-card-actions>
              </v-form>
            </v-card>
            <v-card v-else-if="signUpFailed">
              <v-card-text>
                Unable to complete signup, a error occured: {{ error }}
              </v-card-text>
            </v-card>
            <v-card v-else width="38vw" min-width="400px" :elevation="20" class="pt-5" style="z-index: 22"
              min-height="400">
              <v-card-title>
                Thank you
              </v-card-title>
              <v-card-text v-if="!signUpComplete">
                <template v-if="emailvalidation">
                  <strong>Check your inbox for email verification</strong><br />
                  To ensure your account will be correctly linked to our service, we need to validate your email
                </template>
                <template v-else>
                  Please wait a few minutes while we are preparing your site<br />
                </template>
                <div class="text-center pt-15 pb-10">
                  <v-progress-circular :model-value="progress" color="primary" width="10" size="100">{{ progress
                  }}</v-progress-circular>
                </div>
                <v-row>
                  <v-col class="text-center"><small>{{ progressText }}</small></v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-if="signUpComplete" class="text-center py-10 d-flex justify-center">
                <h3>All done, check your email to start using Qwips</h3>
              </v-card-text>
              <v-card-text v-if="signUpComplete" class="text-center">
                Did not recieved any email? <a :href="'https://' + webSite">Click here to open the site.</a>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-main>
      <canvas class="footer_canvas" data-js-controller="Gradient" data-js-darken-top="" data-transition-in=""
        width="1335"
        height="600"></canvas>
      <front-page-footer />
    </v-container>
    <v-dialog v-model="termsOfServiceDialog" width="75vw">
      <v-card>
        <v-card-text>
          <div class="getterms-document-embed" data-getterms="uZL8t" data-getterms-document="tos"
            data-getterms-lang="en-us"
            data-getterms-mode="direct"></div>
          <div class="getterms-document-embed" data-getterms="uZL8t" data-getterms-document="privacy"
            data-getterms-lang="en-us" data-getterms-mode="direct"></div>
          <div class="getterms-document-embed" data-getterms="uZL8t" data-getterms-document="aup"
            data-getterms-lang="en-us"
            data-getterms-mode="direct"></div>

        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>



<script>
import FrontPageFooter from "./components/FrontPageFooter.vue";
import FrontPageToolbar from "./components/FrontPageToolbar.vue";
import ScrollTrigger from "gsap/ScrollTrigger";
import {
  HubConnectionBuilder, LogLevel
} from '@microsoft/signalr';
import { VueRecaptcha } from 'vue-recaptcha'
import Validation from '@/services/recaptchaValidate.js'
import axios from 'axios'

gsap.registerPlugin(ScrollTrigger);
import gsap from 'gsap'
export default {
  name: 'Frontpage',
  components: {
    FrontPageFooter,
    FrontPageToolbar,
    VueRecaptcha
  },
  data: () => ({
    emailvalidation: true,
    enterCustomCompanyPrefix: false,
    customCompanyPrefix: false,
    companyPrefix: "",
    companyPrefixValidation: false,
    companyPrefixIsValid: null,
    companyPrefixCancellationSource: null,
    terms: false,
    signUpFailed: false,
    termsOfServiceDialog: false,
    recaptcha: null,
    recaptchaValid: false,
    dto: {
      companyName: null,
      companyPrefix: "",
      customCompanyPrefix: false,
      name: null,
      email: null,
      vCaptchaToken: null,
    },
    progress: 0,
    progressMessages: {
      1: "Checking weather...",
      1: "Productivity increases by 50% with each additional cup of coffee.",
      10: "80% of meetings could be emails, but 100% of emails could be ignored.",
      20: "The closer the deadline, the more creative the excuses.",
      30: "Attempting to multitask reduces productivity by 50%, but increases snack consumption by 100%.",
      40: "Taking a 5-minute break every hour increases productivity, but taking a 55-minute break every hour is more fun.",
      50: "The number of unread emails is directly proportional to the level of stress.",
      60: "Adding a task you’ve already done to your to-do list just to cross it off is 100% satisfying.",
      70: "The likelihood of a tech issue is directly proportional to the importance of the task.",
      80: "90% of the task is done in the last 10% of the time.",
      90: "Balancing work and life is like juggling flaming swords while riding a unicycle - impressive if you can do it, but most people just end up with singed eyebrows.",
      99: "Almost there..."
    },
    signUpLoading: false,
    signUpComplete: false,
    canSignUp: false,
    webSite: null,
    hub: null,
    valid: false,
    companyRules: [
      value => {
        if (value) return true
        return 'Company is required.'
      },
      value => {
        if (value?.length > 4) return true
        return 'Company name must be longer than 4 characters.'
      },
    ],
    nameRules: [
      value => {
        if (value) return true
        return 'Name is required.'
      },
      value => {
        if (value?.length > 2) return true
        return 'Name must be longer than 2 characters.'
      },
    ],
    emailRules: [
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
  }),
  computed: {
    validCompany() {
      return this.companyRules.every((v) => v(this.dto.companyName) == true)
    },
    prefix() {
      return this.customCompanyPrefix ? this.dto.companyUrlPrefix : this.cleanedDomainName;
    },
    cleanedDomainName() {
      var domain = this.dto.companyName ?? "";
      domain = domain.toLowerCase();
      return domain.replace(/(?:[^a-z0-9]|(?<=['\"])s)/g, '')
    },
    progressText() {
      const val = parseInt(this.progress ?? 0);
      var keys = Object.keys(this.progressMessages);
      keys.sort(function (a, b) { return a - b; });

      var maxKey = -1;
      for (var i = 0, len = keys.length; i < len; i++) {
        if (maxKey < 0 || keys[i] < val) {
          maxKey = Math.max(maxKey, keys[i]);
        }
      }
      return this.progressMessages[maxKey];
    }
  },
  methods: {
    validate(response) {
      Validation.validate({ Response: response }).then(result => {
        this.recaptchaValid = result.success;
      }).catch(error => console.log(error))
    },
    termsOfService() {
      this.termsOfServiceDialog = true;
      var tosScript = document.createElement('script');
      tosScript.async = true;
      tosScript.setAttribute('src', 'https://app.getterms.io/dist/js/embed.js');
      tosScript.onload = (f) => console.log("script add", f);
      document.head.appendChild(tosScript);
    },
    signup() {
      this.signUpLoading = true;
      this.dto.companyUrlPrefix = this.prefix;
      this.hub.invoke("SignUp", this.dto)
    },
    async start() {
      try {
        await this.hub.start();
        this.canSignUp = true;
      } catch (err) {
        console.log(err);
        setTimeout(this.start, 5000);
      }
    },
    setCompanyPrefix(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    }
  },
  watch: {
    companyPrefix(val) {
      this.companyPrefix = val.replace(/\W/g, "");
    },
    prefix(val) {
      this.companyPrefixIsValid = null;
      if (val.length <= 4) {
        this.companyPrefixIsValid = false;
      }
      this.companyPrefixValidation = true;
      if (this.companyPrefixCancellationSource != null) {
        this.companyPrefixCancellationSource.cancel("Request cancelled by user input");
      }
      this.companyPrefixCancellationSource = axios.CancelToken.source()
      axios.get("/api/v1/domainvalidation", { params: { domainPrefix: val }, cancelToken: this.companyPrefixCancellationSource.token }).then(response => {
        this.companyPrefixValidation = false;
        this.companyPrefixIsValid = response.data;
      })
        .catch(() => {
          this.companyPrefixIsValid = null;
        });
    }
  },
  mounted() {
    function getQueryParam(param) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }
    if (localStorage.getItem("rq") == 'null') {
      console.log("Clearing")
      localStorage.removeItem("rq");
    }
    const emailValue = getQueryParam('email');
    const validationCodeValue = getQueryParam('validationcode');
    const requestId = getQueryParam('rq');
    const validationQueryParams = (emailValue && validationCodeValue && requestId) ? `&email=${emailValue}&validationCode=${validationCodeValue}` : ''
    const connection = new HubConnectionBuilder()
      .withUrl(`/signUpHub/?rq=${requestId ?? window.localStorage.getItem("rq")}${validationQueryParams}`)
      .configureLogging(LogLevel.None)
      .withStatefulReconnect()
      .build();
    connection.on("connect", val => {
      window.localStorage.setItem("rq", val.rq)
      this.recaptcha = val.recaptcha;
    });
    connection.on("reload", val => {
      this.recaptcha = val.recaptcha;
      this.webSite = val.webSite;
      this.signUpComplete = val.signUpComplete;
      this.signUpLoading = val.signUpLoading;
      this.signUpFailed = val.signUpFailed;
      this.progress = val.progress;
      this.error = val.error;
      this.emailvalidation = val.emailValidation;
      if (val.signUpContinue) {
        console.log("Verifying email code")
        const emailValue = getQueryParam('email');
        this.hub.invoke("SignUp", { email: emailValue })
      }
    }),
      connection.on("progress", val => this.progress = val);
    connection.on("error", val => {
      this.signUpFailed = true;
      this.error = val;
    });
    connection.on("complete", val => {
      this.webSite = val;
      this.signUpComplete = true;
    });
    connection.on("emailvalidation", val => {
      this.emailvalidation = val;
    });
    connection.onclose(async () => {
      this.canSignUp = false;
      this.start();
    });

    this.hub = connection;
    this.start();
  },
}
</script>
<style scoped>
@import './assets/main.css';

.footer {
  background-color: rgba(0, 0, 0, 0);
  font-size: 0.8em;
  z-index: 21;
}

.header_canvas {
  background: linear-gradient(-45deg, #ee7752, #23a6d5);
  background-size: 200% 200%;
  animation: gradient 15s ease infinite;
  position: absolute;
  clip-path: polygon(0 0, 100% 0, 100% 75%, 0 100%);
  width: 100%;
  height: 320px;
  top: -0px;
  left: 0px;
  border: none;
  z-index: 20;
}

.gradient-info {
  background: linear-gradient(-45deg, rgb(79, 200, 236), #e18f01);
  background-size: 200% 200%;
  animation: gradient 15s ease infinite;
  clip-path: polygon(0 0, 100% 0, 100% 75%, 0 100%);
  height: 140px;
  border: none;
  z-index: 20;
}


.footer_canvas {
  background: linear-gradient(-45deg, #ee7752, #23a6d5);
  background-size: 200% 200%;
  animation: gradient 15s ease infinite;
  position: absolute;
  clip-path: polygon(0 20%, 100% 0, 100% 100%, 0 100%);
  width: 100%;
  height: 300px;
  bottom: -0px;
  left: 0px;
  border: none;
  z-index: 20;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.main_wrap {
  z-index: 21;
  max-width: 900px;
}
</style>
